// extracted by mini-css-extract-plugin
module.exports = {"header":"contact-module--header--3OMoB","changing":"contact-module--changing--1aawp","block":"contact-module--block--1GMqv","contactInfo":"contact-module--contactInfo--2V_c0"};